import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import axios from "axios";
import DigiFormItem from "./DigiFormItem";

class DigiFormContainer extends React.Component {
  state = {
    loading: false,
    done: false,
    fieldErrors: {},
    formFields: this.props.formFields
  };

  render() {
    const {
      loading,
      fieldErrors,
      formFields
    } = this.state;

    return (
      <div>
        <form onSubmit={this.submit}>
          {Object.keys(formFields).map((formField, index) =>
            <DigiFormItem
              key={index}
              formFieldKey={formField}
              formField={formFields[formField]}
              formName={this.props.formName}
              fieldErrors={fieldErrors}
              onChange={this.handlerChangeField}
            />
          )}
          <button
            className={classnames("btn btn-block btn-pink", {
              disabled: false
            })}
            type="submit"
          >SAVE
          </button>
        </form>
      </div>
    );
  }

  handlerChangeField = (newValue, key) => {
    const formFields = this.state.formFields;
    !(key in formFields) && (formFields[key] = {});
    formFields[key].value = newValue;

    this.setState({ formFields: formFields });
  };

  processRailsErrors = (errorFields) => {
    const fieldErrors = this.state.fieldErrors;
    Object.keys(errorFields).forEach(errorFieldKey => {
      fieldErrors[errorFieldKey] = errorFields[errorFieldKey];
    });
    this.setState({ fieldErrors: fieldErrors });
  };

  buildDataForm = () => {
    const data = new FormData();

    Object.keys(this.state.formFields).forEach(key => {
      let value = this.state.formFields[key].value;
      if (key == "answers") {
        Object.keys(value).forEach(answerKey => {
          data.append(`${this.props.formName}[${key}][${answerKey}]`, value[answerKey]);
        })
      } else if (key == "attachments_attributes") {
        value.forEach(file => {
          if (file instanceof File) {
            data.append(`${this.props.formName}[attachments][]`, file, file.name);
          } else if (file._destroy) {
            data.append(`${this.props.formName}[${key}][][id]`, file.id);
            data.append(
              `${this.props.formName}[${key}][][_destroy]`,
              "true"
            );
          }
        });
      } else if (key == "signatures_attributes") {
        const dataSignatures = value.filter(
          item =>
            (item.data_image && item.data_image.includes("data:image/")) ||
            item._destroy
        );
        if (dataSignatures.length > 0) {
          dataSignatures.forEach(item => {
            Object.keys(item).forEach(key => {
              data.append(
                `${this.props.formName}[signatures_attributes][][${key}]`,
                item[key]
              );
            });
          });
        }
      } else if (Array.isArray(value)) {
        value.forEach(nestedFields => {
          let nestedFieldId = nestedFields.id ? nestedFields.id : nestedFields._id || new Date().getTime() + Math.floor(Math.random() * 100);
          Object.keys(nestedFields).forEach(nestedKey => {
            data.append(
              `${this.props.formName}[${key}][${nestedFieldId}][${nestedKey}]`, nestedFields[nestedKey]
            );
          })
        })
      } else {
        data.append(`${this.props.formName}[${key}]`, value);
      };
    });

    return data;
  };

  submit = e => {
    e.preventDefault();

    let that = this;

    if (this.state.loading) {
      return;
    }

    const data = this.buildDataForm();

    this.setState({ loading: true, fieldErrors: {} });

    const request = this.props.formType == "edit"
      ? axios.put(
          this.props.formUrl,
          data
        )
      : axios.post(
          this.props.formUrl,
          data
        );

    request
      .then(request => {
        toastr.success(this.props.formType == "edit" ? "Form Updated" : "Form Created");
        this.setState({ done: true, loading: false });

        setTimeout(() => {
          window.location.href = this.props.redirectUrl;
        }, 700);
      })
      .catch(function(error) {
        if(error.response.data) {
          toastr.error("There is an error, please check the required fields");
        } else {
          toastr.error("There is an unknown error, please contact support");
        }

        that.processRailsErrors(error.response.data);
        that.setState({ loading: false, done: false });
      });
  };
}

DigiFormContainer.propTypes = {
  formType: PropTypes.string,
  formName: PropTypes.string,
  formUrl: PropTypes.string,
  formFields: PropTypes.object
};

export default DigiFormContainer;
